var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 3.5,
    fill: "#FFEED9",
    stroke: "#FF8A2C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.1746,
    cy: 13.1746,
    r: 7.40165,
    transform: "rotate(-45 13.1746 13.1746)",
    stroke: "#FF8A2C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11914 18.2297L18.3489 8",
    stroke: "#FF8A2C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/RemoveIcon.13e9697161dfcc41977f9e780204a787.svg";
export { ForwardRef as ReactComponent };